import classNames from 'classnames';

interface PageContentSectionsProps {
  className?: string;
  children: React.ReactNode;
}

export function PageContentSections({ children, className }: PageContentSectionsProps) {
  return (
    <div data-component="PageContentSections" className={classNames('flex flex-col gap-5', className)}>
      {children}
    </div>
  );
}
